import React from "react";
import { List, Card, Typography, Button, Col, Empty } from "antd";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
const { Text } = Typography;
export const PendingRequests = ({ pendingRequests, darkMode }) => {
  const navigate = useNavigate();
  const styles = {
    card: {
      borderRadius: 8,
      marginBottom: 24,
      backgroundColor: darkMode ? "#1f1f1f" : "#fff",
      borderColor: darkMode ? "#303030" : "#f0f0f0",
    },
    cardTitle: {
      color: darkMode ? "rgba(255, 255, 255, 0.85)" : undefined,
    },
    trainingCard: {
      height: "100%",
      display: "flex",
      flexDirection: "column",
    },
    listItem: {
      padding: "8px 0",
      borderBottom: `1px solid ${darkMode ? "#303030" : "#f0f0f0"}`,
    },
    textColor: {
      color: darkMode ? "rgba(255, 255, 255, 0.85)" : undefined,
    },
    secondaryTextColor: {
      color: darkMode ? "rgba(255, 255, 255, 0.45)" : "rgba(0, 0, 0, 0.45)",
    },
    noData: {
      textAlign: "center",
      padding: "24px 0",
      color: darkMode ? "rgba(255, 255, 255, 0.45)" : "#999",
    },
  };
  return (
    <Col xs={24} lg={8}>
      <Card
        title="Pending Training Requests"
        style={{ ...styles.card, ...styles.trainingCard }}
        headStyle={styles.cardTitle}
        extra={
          pendingRequests.length !== 0 ? (
            <Button
              type="link"
              onClick={() =>
                navigate("/pending-request-list", {
                  state: { darkMode, pendingRequests },
                })
              }
            >
              View All
            </Button>
          ) : (
            ""
          )
        }
      >
        {pendingRequests.length === 0 ? (
          <Empty description="No Pending Request Available yet!" />
        ) : (
          <List
            size="small"
            dataSource={pendingRequests.slice(0, 3)}
            renderItem={(request) => (
              <List.Item style={styles.listItem}>
                <List.Item.Meta
                  title={
                    <Text strong style={styles.textColor}>
                      {request.title}
                    </Text>
                  }
                  description={
                    <>
                      <Text style={styles.secondaryTextColor}>
                        Learner: {request.learnerFirstName} {request.learnerLastName}
                      </Text>
                      <br />
                      <Text style={styles.secondaryTextColor}>
                        Manager: {request.managerFirstName} {request.managerLastName}
                      </Text>
                    </>
                  }
                />
              </List.Item>
            )}
          />
        )}
      </Card>
    </Col>
  );
};
PendingRequests.propTypes = {
  darkMode: PropTypes.bool,
  pendingRequests: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      learnerFirstName: PropTypes.string.isRequired,
      learnerLastName: PropTypes.string.isRequired,
      managerFirstName: PropTypes.string.isRequired,
      managerLastName: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    })
  ).isRequired,
};
